import React from 'react';
import intl from '$intl';
import ItemModel from '$fbusiness/models/item';
import { Backdrop } from '@mui/material';
import { BackdropWrapper } from './styles';

interface ScanBackdropProps {
  show: boolean;
  onClose: Function;
  qtyMode?: boolean;
  barcode?: string;
  qtyAdded?: number;
  item?: ItemModel | null;
}

const ScanBackdrop: React.FC<ScanBackdropProps> = ({
  show,
  qtyAdded,
  qtyMode = false,
  barcode,
  item,
  onClose,
}) => {
  const msg = item ? `Adding ${qtyAdded || ''} ${item.name}...` : item === null ? `${barcode} Not Found` : '';
  return (
    <BackdropWrapper
      className={`scan-backdrop ${qtyMode && 'qty-mode'}`}
      open={show}
      onClick={() => onClose()}>
      <div>
        <div>{intl(qtyMode ? 'SCREEN.PO.ENTER_QUANTITY' : 'SCREEN.PO.SCANNING')}</div>
        <div className="message">{msg}</div>
      </div>
    </BackdropWrapper>
  );
};

export default ScanBackdrop;
